<img src="/assets/img/logo.svg" alt="Logo" *ngIf="!short && !small" />
<img src="/assets/img/logo__short.svg" alt="Logo" *ngIf="short || small" />
